export const companyFeeColumns = [
    { label: "Nome", value: "name" },
    { label: "Produto", value: "product" },
    { label: "Valor", value: "amount"},
  ];